<!-- Button trigger modal -->
<div class="accordion accordion-flush" id="accordionFlushExample">
    <div *ngFor="let doc of data.dto; let i = index" class="accordion-item">
        <h2 class="accordion-header" id="{{'flush' + i}}">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#col' + i" aria-expanded="false" [attr.aria-controls]="'col' + i">
                {{doc.file.name}}
            </button>
        </h2>
        <div id="{{'col' + i}}" class="accordion-collapse collapse" [attr.aria-labelledby]="'flush' + i" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
                <div class="row">
                    <div class="col-sm-12 border-bottom" style="padding-bottom: 10px;">
                        <div class="float-end" *ngIf="!doc.phaseOut">
                            <button type="button" class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="subscriber(doc.uid)">
                                ADD 
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" style="padding-bottom: 4px;" viewBox="0 0 16 16">
                                    <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <ul class="list-group list-group-flush">
                            <li *ngFor="let sub of doc.subscribers" class="list-group-item">{{sub.email}}</li>
                        </ul>
                    </div>
                    <div class="col-sm-12" style="padding-top: 10px;" *ngIf="doc.checkBtn && !doc.phaseOut">
                        <button type="button" class="btn btn-outline-dark float-end" style="padding-top: 10px;" (click)="complete(doc.uid)">Complete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Subscriber</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <input type="email" class="form-control" id="floatingInput" placeholder="E-mail"
                        [(ngModel)]="email">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="associateSubscriber()">Register</button>
            </div>
        </div>
    </div>
</div>
